"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var R = require("ramda");
var AbstractImage = require("abstract-image");
function createLinearAxis(min, max, label) {
    return {
        type: "linear",
        min: min,
        max: max,
        label: label
    };
}
exports.createLinearAxis = createLinearAxis;
function createLogarithmicAxis(min, max, label) {
    return {
        type: "logarithmic",
        min: min,
        max: max,
        label: label
    };
}
exports.createLogarithmicAxis = createLogarithmicAxis;
var linearMultiples = [1, 2, 5];
var linearPowers = [-2, -1, 0, 1, 2, 3, 4, 5, 6];
function getTicks(desiredTicks, axis) {
    switch (axis.type) {
        case "linear":
            return getLinearTicks(desiredTicks, axis.min, axis.max);
        case "logarithmic":
            return getLogarithmicTicks(desiredTicks, axis.min, axis.max);
        default:
            return [];
    }
}
exports.getTicks = getTicks;
function getLinearTicks(desiredTicks, min, max) {
    var best;
    for (var _i = 0, linearPowers_1 = linearPowers; _i < linearPowers_1.length; _i++) {
        var power = linearPowers_1[_i];
        var base = Math.pow(10, power);
        for (var _a = 0, linearMultiples_1 = linearMultiples; _a < linearMultiples_1.length; _a++) {
            var multiple = linearMultiples_1[_a];
            var step = base * multiple;
            var cMin = Math.ceil(min / step);
            var cMax = Math.floor(max / step);
            var ticks = cMax - cMin + 1;
            if (!best ||
                Math.abs(best.ticks - desiredTicks) > Math.abs(ticks - desiredTicks)) {
                best = {
                    min: cMin * step,
                    step: step,
                    ticks: ticks
                };
            }
        }
    }
    if (!best) {
        return [];
    }
    var b = best;
    return R.range(0, b.ticks).map(function (l) { return b.min + b.step * l; });
}
exports.getLinearTicks = getLinearTicks;
var logarithmicAlternatives = [
    [0],
    [0, 5],
    [0, 1, 2, 5],
    [0, 1, 2, 3, 5],
    [0, 1, 2, 3, 5, 8],
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
];
function getLogarithmicTicks(desiredTicks, min, max) {
    var minPow = Math.floor(Math.log10(min)) - 1;
    var maxPow = Math.ceil(Math.log10(max)) + 1;
    var powers = R.range(0, maxPow - minPow + 1).map(function (p) { return minPow + p; });
    var alternatives = logarithmicAlternatives.map(function (stepAlt) {
        var altLines = powers.reduce(function (lines, power) {
            var base = Math.pow(10, power);
            var powerLines = stepAlt.map(function (i) { return i * base; });
            return lines.concat(powerLines);
        }, []);
        return altLines.filter(function (l) { return l >= min && l <= max; });
    });
    var bestLines = alternatives.reduce(function (prev, alt) {
        return Math.abs(alt.length - desiredTicks) < Math.abs(prev.length - desiredTicks)
            ? alt
            : prev;
    });
    return bestLines;
}
exports.getLogarithmicTicks = getLogarithmicTicks;
function transformPoint(point, xMin, xMax, yMin, yMax, xAxis, yAxis) {
    var x = transformValue(point.x, xMin, xMax, xAxis);
    var y = transformValue(point.y, yMin, yMax, yAxis);
    return AbstractImage.createPoint(x, y);
}
exports.transformPoint = transformPoint;
function transformValue(value, min, max, axis) {
    if (!axis) {
        return value;
    }
    var range = max - min;
    switch (axis.type) {
        case "linear":
            return min + range * linearTransform(value, axis.min, axis.max);
        case "logarithmic":
            return min + range * logarithmicTransform(value, axis.min, axis.max);
        default:
            return 0;
    }
}
exports.transformValue = transformValue;
function inverseTransformValue(value, min, max, axis) {
    if (!axis) {
        return value;
    }
    var range = max - min;
    switch (axis.type) {
        case "linear":
            return inverseLinearTransform((value - min) / range, axis.min, axis.max);
        case "logarithmic":
            return inverseLogarithmicTransform((value - min) / range, axis.min, axis.max);
        default:
            return 0;
    }
}
exports.inverseTransformValue = inverseTransformValue;
function linearTransform(value, min, max) {
    return (value - min) / (max - min);
}
exports.linearTransform = linearTransform;
function logarithmicTransform(value, min, max) {
    if (value > 0) {
        return ((Math.log10(value) - Math.log10(min)) /
            (Math.log10(max) - Math.log10(min)));
    }
    else if (value < 0) {
        return 0.0;
    }
    else {
        return 0.0;
    }
}
exports.logarithmicTransform = logarithmicTransform;
function inverseLinearTransform(value, min, max) {
    return min + value * (max - min);
}
exports.inverseLinearTransform = inverseLinearTransform;
function inverseLogarithmicTransform(value, min, max) {
    return Math.pow(10, value * (Math.log10(max) - Math.log10(min)) + Math.log10(min));
}
exports.inverseLogarithmicTransform = inverseLogarithmicTransform;
//# sourceMappingURL=axis.js.map